import { render, staticRenderFns } from "./AdminPageIndexPage.vue?vue&type=template&id=65d6a652&scoped=true"
import script from "./AdminPageIndexPage.vue?vue&type=script&lang=js"
export * from "./AdminPageIndexPage.vue?vue&type=script&lang=js"
import style0 from "./AdminPageIndexPage.vue?vue&type=style&index=0&id=65d6a652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6a652",
  null
  
)

export default component.exports